module.exports = __webpack_public_path__ + "static/media/assignments-icon.16e3ab26.svg";